import React from 'react';
import DocumentTitle from 'react-document-title';
import moment from 'moment';

import HeaderMain from 'components/HeaderMain';
import Page from 'components/Page';
import PageBody from 'components/PageBody';
import { P } from 'components/Typography';

const birthMonth = moment('10/1990', 'MM/YYYY');

export default () => (
  <Page>
    <DocumentTitle title="Chris Tieman // Developer" />
    <HeaderMain />
    <PageBody compact>
      <P>
        Howdy! Chris Tieman here, and thanks for stopping by. I’m a {moment().diff(birthMonth, 'y')} year old Developer,
        Designer, and proud father of 3 furry children located in the heart of Fishers, Indiana. It's also quite known
        by my friends that I have an unhealthy obsession with ducks.
      </P>
      <P>
        Since I was little, I’ve always liked to tinker with things. I’d take them apart, see how they worked, and put
        them back together again. So when I discovered code, it was love at first keystroke. I’d found a profession
        dedicated to reducing a final product into it’s most basic form before building it back up again, and I knew
        what I wanted to do with my life.
      </P>
      <P>
        Everything about the web fits my personality and my passion. It’s constantly changing. It never stops evolving.
        Each day I boot up my computer, there is something new to learn, and I know that when I head into work there is
        a fresh puzzle on my monitor, waiting for me to solve it.
      </P>
      <P>
        Even if the project in front of me doesn’t offer the challenges that I crave, it’s not a problem. I know that
        after I power through a less interesting assignment, a better one exists later in the queue&nbsp;or on my system
        at home. I can practice my trade anywhere I want and spend my free time devising obstacles difficult enough to
        keep pushing my talents further and further.
      </P>
      <P>
        I’ve made apps, websites, and many other fun web tools. Creating things that both intrigue me and bring joy to
        others has been an increasingly worthwhile pursuit as my skills have grown.
      </P>
      <P>I never want to stop learning, and, in a field like this, I don’t think I ever will.</P>
    </PageBody>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/Home.js